<template>
  <div id="app">
    <NavBar />
    <main class="main-content">
      <router-view />
    </main>
    <AuthDialog v-if="showAuthDialog" />
    <InsufficientDialog />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import NavBar from './components/NavBar.vue'
import AuthDialog from './components/AuthDialog.vue'
import InsufficientDialog from './components/InsufficientDialog.vue'

export default {
  name: 'App',
  components: { NavBar, AuthDialog, InsufficientDialog },
  computed: {
    ...mapState({
      showAuthDialog: state => state.showAuthDialog
    })
  },
  mounted() {
    this.restoreSession()
  },
  methods: {
    restoreSession() {
      var token = localStorage.getItem('sb-access-token')
      if (!token) return
      var userStr = localStorage.getItem('sb-user')
      if (userStr) {
        try {
          var savedUser = JSON.parse(userStr)
          var user = {
            id: savedUser.id,
            email: savedUser.email,
            user_metadata: { full_name: savedUser.userName || savedUser.email.split('@')[0] }
          }
          this.$store.commit('SET_USER', user)
          this.$store.dispatch('fetchCredits')
        } catch (e) {
          // 解析失败忽略
        }
      }
    }
  }
}
</script>

<style>
#app {
  min-height: 100vh;
  background: #0a0a0f;
  color: #ffffff;
}

.main-content {
  padding-top: 64px;
  min-height: calc(100vh - 64px);
}
</style>
